module.exports = __webpack_public_path__ + "img/zz13.a9d5ce5f.png";